import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';

@Injectable({
    providedIn: 'root',
})
export class ExtensionAttributeService extends BaseService {
    entityName = 'ExtensionAttribute';
    serviceCode = 'admin';

    constructor(http: HttpClient, injector: Injector,
                private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }
}
